import { useQuery } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getVisitServiceProfile } from "../services/goHireService";

export const useVisitServiceProfile = (userId: number) => {
  return useQuery({
    queryKey: GO_SERVICE_QUERY_KEYS.visitServiceProfile(userId),
    queryFn: () => getVisitServiceProfile(userId),
    enabled: !!userId,
  });
};
